import { create } from 'zustand';
import useLoadingStore from './use-loading';
import { makeRequest } from 'api/api-client';
import { HTTP } from 'constants/http-method';
import { API_ENDPOINTS } from 'api/endpoints';

const useStaffMemberActivity = create((set) => ({
  activitiesLoading: false,
  activities: [],
  pagination: {
    pageSize: 10,
    totalItems: 0,
    totalPages: 0,
    currentPage: 1,
  },
  // Function to reset currentPage only when an action happens
  resetCurrentPage: () => {
    set((state) => ({
      pagination: {
        ...state.pagination,
        currentPage: 1,
      },
    }));
  },

  // Function to get activities
  getActivities: async ({ id, query = null, successCallback }) => {
    set({ activitiesLoading: true });
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.GET,
        API_ENDPOINTS.GET_CAREGIVER_ACTIVITIES,
        null,
        query,
        id
      );

      if (response.success) {
        set({
          activities: response.data?.data || [],
          pagination: {
            pageSize: response.data?.pagination?.limit,
            totalItems: response.data?.pagination?.total,
            currentPage: response.data?.pagination?.page,
            totalPages: response.data?.pagination?.totalPages,
          },
        });
        successCallback && successCallback();
      }
    } catch (error) {
    } finally {
      set({ activitiesLoading: false });
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to add the note
  addNote: async ({ data, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.POST,
        API_ENDPOINTS.ADD_CAREGIVER_NOTE,
        data
      );

      // if (response.success) {
      //   await useStaffMemberActivity.getState().getActivities({
      //     id: data.userId,
      //     successCallback: () => {
      //       useStaffMemberActivity.getState().resetCurrentPage(); // Reset page
      //       successCallback && successCallback(response);
      //     },
      //   });
      // }

      if (response.success) {
        set((state) => {
          const updatedActivities = [response.data, ...state.activities];
          const updatedTotalItems = updatedActivities.length;
          const updatedTotalPages = Math.ceil(
            updatedTotalItems / state.pagination.pageSize
          );
          return {
            activities: updatedActivities,
            pagination: {
              ...state.pagination,
              totalItems: updatedTotalItems,
              totalPages: updatedTotalPages,
            },
          };
        });
        // Reset page
        useStaffMemberActivity.getState().resetCurrentPage();
        successCallback && successCallback(response);
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to delete the note
  deleteNote: async ({ id, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.DELETE,
        API_ENDPOINTS.DELETE_CAREGIVER_NOTE,
        null,
        null,
        id
      );

      if (response.success) {
        set((state) => {
          const updatedActivities = state.activities.filter(
            (activity) => activity.id !== id
          );
          const updatedTotalItems = updatedActivities.length;
          const updatedTotalPages = Math.ceil(
            updatedTotalItems / state.pagination.pageSize
          );

          return {
            activities: updatedActivities,
            pagination: {
              ...state.pagination,
              totalItems: updatedTotalItems,
              totalPages: updatedTotalPages,
            },
          };
        });

        successCallback && successCallback(response);
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to update the note
  updateNote: async ({ id, data, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.PUT,
        API_ENDPOINTS.UPDATE_CAREGIVER_NOTE,
        data,
        null,
        id
      );

      if (response.success) {
        set((state) => {
          // Find the updated note (activity)
          const updatedNote = state.activities.find(
            (activity) => activity.id === id
          );

          // If the note is found, update it and move it to the first position
          if (updatedNote) {
            const updatedActivities = [
              { ...updatedNote, ...response?.data?.data }, // Updated note
              ...state.activities.filter((activity) => activity.id !== id), // Rest of the activities
            ];

            return {
              activities: updatedActivities,
              pagination: {
                ...state.pagination,
                currentPage: 1,
              },
            };
          }

          // If the note is not found, return the state as is
          return state;
        });

        successCallback && successCallback(response);
      }
    } catch (error) {
      // Handle error
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },
}));

export default useStaffMemberActivity;
